import { instance3 } from "App/constants";
import { isNull, statusSucess } from "App/utils/helpers";
import moment from "moment";

export const deletePembayaranByID = async (formData) => {
  try {
    const res = await instance3.delete("/rekap-tagihan/v2/delete", {
      data: formData,
    });

    if (statusSucess(res.data.status)) {
      return {
        state: true,
        message: res.data.message,
        // message: "Penghapusan pembayaran dalam proses, periksa log proses secara berkala",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteDetailPembayaranByID = async (formData) => {
  try {
    const res = await instance3.delete(
      "/rekap-tagihan/v2/bayar/detail/delete",
      {
        data: formData,
      }
    );

    if (statusSucess(res.data.status)) {
      return {
        state: true,
        message: res.data.message,
        // message: "Penghapusan pembayaran dalam proses, periksa log proses secara berkala",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const bayarDetailTagihan = async (id) => {
  try {
    const res = await instance3.post("/rekap-tagihan/v2/bayar/detail", {
      id_rekap_bayar: id,
    });

    if (statusSucess(res.data.status)) {
      return {
        state: true,
        data: res?.data?.data ?? [],
        message: res.data.message,
        // message: "Penghapusan pembayaran dalam proses, periksa log proses secara berkala",
      };
    } else {
      return {
        state: false,
        data: [],
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const STATE_FILTER_DETAIL_PEMBAYARAN = {
  id_bayar_rekap: "",
  id_tagihan: "",
  guarantor_name: "",
  tanggal_awal: "",
  tanggal_akhir: "",
  status: "",
  pages: 1,
  limit: 10,
};

export const getDetailBayarRekapTagihan = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.get(
      "/rekap-tagihan/v2/bayar/list-detail-bayar-rekap-tagihan",
      {
        params: {
          id_bayar_rekap: parseInt(formFilter.id_bayar_rekap),
          id_tagihan: formFilter.id_tagihan,
          guarantor_name: formFilter.guarantor_name,
          tanggal_awal: isNull(formFilter.tanggal_awal)
            ? ""
            : moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
          tanggal_akhir: isNull(formFilter.tanggal_akhir)
            ? ""
            : moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
          status: formFilter.status,
          pages: pages,
          limit: limit,
        },
      }
    );

    const res = api.data;
    if (statusSucess(res.status)) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.pages),
          limit: parseInt(res.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 0,
          limit: 0,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "100px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    width: "100px",
  },
  {
    id: "idgl",
    disablePadding: true,
    label: "IDGL",
    sort: false,
    align: "left",
    minWidth: "130px",
  },
  {
    id: "tanggal",
    disablePadding: true,
    label: "TANGGAL",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: true,
    label: "JUMLAH",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "diskon",
    disablePadding: true,
    label: "DISKON",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_ref",
    disablePadding: true,
    label: "JUMLAH REF",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_real",
    disablePadding: true,
    label: "JUMLAH REAL",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "kas",
    disablePadding: true,
    label: "KAS",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tipe_bayar",
    disablePadding: true,
    label: "TIPE BAYAR",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tipe_kartu",
    disablePadding: true,
    label: "TIPE KARTU",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_kartu",
    disablePadding: true,
    label: "NO. KARTU",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_transfer",
    disablePadding: true,
    label: "NO. TRANSFER",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED AT",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const jalankanRekrusifPembayaranRekap = async (data) => {
  try {
    const api = await instance3.post(
      "/rekap-tagihan/v2/bayar/detail/recursive",
      data
    );
    const res = api.data;
    if (statusSucess(res.status)) {
      return {
        state: true,
        message: res.message,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCellsDetailPembayaran = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "tagihan_id",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama_rm",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "id_rm",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
    minWidth: "130px",
  },
  {
    id: "status_tagihan",
    disablePadding: true,
    label: "STATUS TAGIHAN",
    sort: false,
    align: "center",
    minWidth: "130px",
  },
  {
    id: "tgl_tagihan",
    disablePadding: true,
    label: "TGL TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "asuransi",
    disablePadding: true,
    label: "ASURANSI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "no_asuransi",
    disablePadding: true,
    label: "NO. ASURANSI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "total_tagihan",
    disablePadding: true,
    label: "TOTAL TAGIHAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "dibayar",
    disablePadding: true,
    label: "DIBAYAR",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "sisa",
    disablePadding: true,
    label: "SISA",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
];
